import React, { useState } from 'react';
import { Play, Trophy, User, Edit2, Crown } from 'lucide-react';
import { GAME_DURATION } from '../utils/gameUtils';

export default function TitleScreen({ onStart, highScores, onShowRanking, userName, onUpdateName, onStartPvP }) {
  const bestScore = highScores.length > 0 ? highScores[0].score : 0;
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(userName);

  const handleNameSubmit = (e) => {
    e.preventDefault();
    onUpdateName(editName);
    setIsEditing(false);
  }

  return (
    <div className="text-center space-y-6 animate-fade-in py-2">
      {/* ユーザー名＆ヘッダー */}
      <div className="flex justify-between items-center bg-gray-50 p-2 rounded-lg border border-gray-100">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <User className="w-4 h-4" />
          {isEditing ? (
            <form onSubmit={handleNameSubmit} className="flex items-center">
              <input
                className="border border-gray-300 rounded px-1 py-0.5 text-xs w-24 focus:outline-none focus:border-orange-500"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                onBlur={() => {
                  onUpdateName(editName);
                  setIsEditing(false);
                }}
                autoFocus
              />
            </form>
          ) : (
            <span className="font-bold cursor-pointer hover:text-orange-600 flex items-center gap-1" onClick={() => {
              setEditName(userName);
              setIsEditing(true);
            }}>
              {userName} <Edit2 className="w-3 h-3 opacity-50" />
            </span>
          )}
        </div>
        {bestScore > 0 && (
          <div className="flex items-center gap-1 text-yellow-600 font-bold text-sm">
            <Trophy className="w-4 h-4" />
            <span>Best: {bestScore}</span>
          </div>
        )}
      </div>


      <div className="space-y-3">
        <h2 className="text-lg font-bold text-gray-700">ルール（更新版）</h2>
        <ul className="text-left text-sm text-gray-600 bg-orange-50 p-5 rounded-xl space-y-3 border border-orange-100">
          <li className="flex items-start gap-2">
            <span className="text-orange-500 font-bold bg-white w-5 h-5 rounded-full flex items-center justify-center text-xs shadow-sm">1</span>
            <span>
              <strong className="text-gray-800">「{GAME_DURATION}秒」</strong>以内に、表示される文字から始まる単語を入力！
            </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-orange-500 font-bold bg-white w-5 h-5 rounded-full flex items-center justify-center text-xs shadow-sm">2</span>
            <span>「ん」で終わる言葉はNG！</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-orange-500 font-bold bg-white w-5 h-5 rounded-full flex items-center justify-center text-xs shadow-sm">3</span>
            <span>「6文字以上」で<strong className="text-gray-800">+1点</strong>、「8文字以上」で<strong className="text-gray-800">+2点</strong>！</span>
          </li>
        </ul>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={onShowRanking}
          className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-4 px-4 rounded-xl shadow-lg transition-transform active:scale-95 flex flex-col items-center justify-center gap-1"
        >
          <Crown className="w-6 h-6" />
          <span className="text-sm">ランキング</span>
        </button>

        <button
          onClick={onStart}
          className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold py-4 px-4 rounded-xl shadow-lg transition-transform active:scale-95 flex flex-col items-center justify-center gap-1"
        >
          <Play className="w-6 h-6 fill-current" />
          <span className="text-sm">スタート</span>
        </button>

        <button
          onClick={onStartPvP}
          className="col-span-2 mt-2 bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 text-white font-bold py-3 px-4 rounded-xl shadow-lg transition-transform active:scale-95 flex items-center justify-center gap-2"
        >
          <span className="text-xl">⚔️</span>
          <span className="text-sm">対戦モード (Beta)</span>
        </button>
      </div>
    </div>
  );
}
